var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"dense":"","flat":"","label":(this.$vuetify.theme.dark) ? 'On' : 'Off'},on:{"change":_vm.toggle_dark_mode},model:{value:(this.$vuetify.theme.dark),callback:function ($$v) {_vm.$set(this.$vuetify.theme, "dark", $$v)},expression:"this.$vuetify.theme.dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }